import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthenticatedNavigationProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component that handles navigation to either dashboard or landing page
 * based on authentication status
 */
const AuthenticatedNavigation: React.FC<AuthenticatedNavigationProps> = ({ children, className }) => {
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      // User is logged in, go to dashboard
      navigate('/dashboard');
    } else {
      // User is not logged in, go to landing page
      navigate('/');
    }
  };

  return (
    <div onClick={handleHomeNavigation} className={className}>
      {children}
    </div>
  );
};

export default AuthenticatedNavigation;